// extracted by mini-css-extract-plugin
export default {"container":"xyWb7sGSAmakmnl3NJl1","typography":"jZaqIWx7zqG1_SwqT5ch"};